import React, { Component, useState, useEffect } from "react";
import Select from "react-select";
import {useNavigate, useSearchParams, Navigate, useLocation } from "react-router-dom";
import Form from 'react-bootstrap/Form';
import Table from 'react-bootstrap/Table';
import Full_Calendar from './full-calendar';
import axios from "axios";
import { useTranslation } from "react-i18next";
import swal from "sweetalert";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import HomeBanner from "../images/feature-banner.png";
import Arrow from "../images/Down_Arrow_3_.svg"
import RedStar from "../images/star-red.svg"
import GreyStar from "../images/star-grey.svg"



function Features(props) { 
  console.log("====================>",props)
  

  const [state, setState] = useState({
      seldate: new Date(), // or some valid initial value
  });

 


  const token = localStorage.getItem("token");
  const navigate = useNavigate();
  const [searchParams] = useSearchParams()

  
  
  
  
  

  const { t, i18n } = useTranslation();

  
  const calDate = searchParams.get('seldate');
   
    
  const [startDate, setStartDate] = useState(new Date( (calDate ? new Date(calDate) : new Date ()) ));

  const [clicked, setClicked] = useState('');
  const [clickedType, setclickedType] = useState('');
  const [searchData, setSearchData] = useState([]);
  // const [disDay, setDisDay] = useState(startDate.getDay());
  // const [disDate, setDisDate] = useState(startDate.getDate());
  // const [disMonthYear, setDisMonthYear] = useState(startDate.getMonth());

  const [disDay, setDisDay] = useState('');
  const [disDate, setDisDate] = useState('');
  const [disMonthYear, setDisMonthYear] = useState('');

  const [jieQiStart, setJieQiStart] = useState('');
  const [jieQiEnd, setJieQiEnd] = useState('');
  const [holidays, setHolidays] = useState('');
  const [holidaysTer, setHolidaysTer] = useState('');
  const [mulLeft, setMulLeft] = useState([]);

  const [san, setSan] = useState(''); // CONCERNS
  const [yang, setYang] = useState(''); // CONCERNS
  const [earth, setEarth] = useState(''); // CONCERNS
  const [gong, setGong] = useState(''); // CONCERNS
  const [breaker, setBreaker] = useState(''); // CONCERNS
  
  const [chDate, setChDate] = useState(''); // China Date
  const [hourFore, setHourFore] = useState([]); // Hour Forecast
  const [zLuck, setZLuck] = useState([]); // Zodiac luck
  const [zHealth, setZHealth] = useState([]); // Zodiac health
  const [zCareer, setZCareer] = useState([]); // Zodiac career
  const [zWealth, setZWealth] = useState([]); // Zodiac wealth
  
  const [good, setGood] = useState([]); // Good
  const [bad, setBad] = useState([]); // Bad

  const [suitLeft, setSuitLeft] = useState([]); // SUIT
  const [avoid, setAvoid] = useState([]); // AVOID
  const [starRating, setStarRating] = useState([]); // Starts
  const [lunarCalenderData, setLunarCalenderData] = useState([]); //Lunar data

  ///////////////////////// SEARCH /////////////////////////
  const [searchTitle, setSearchTitle] = useState('');
  const [searchSDate, setSearchSDate] = useState(new Date());
  const [searchEDate, setSearchEDate] = useState(new Date());
  const [selectedIds, setSelectedIds ] = useState([]);
  const [allEvents, setAllEvents] = useState([]); 
  const [selectedDays, setSelectedDays ] = useState([]); 
  const [days, setDays] = useState([]); 
  const [zLuckSearch, setZLuckSearch] = useState([]); 

  ///////////////////////// SEARCH /////////////////////////

  useEffect(()=>{

    

    axios.get(process.env.REACT_APP_API_KEY+"api/all-event",
    {
      params: {},
      headers: {
          "Content-type": "Application/json",
          "Accept": "Application/json",
          "Authorization": `Bearer `+token,
          "sellang": localStorage.getItem("selectLang")
      }   
    }).then((res) => {
      console.log('EEEEs: ', res);

      var re_Data = res.data; 
      
      if(re_Data.status == true){ // ?.
        setAllEvents(re_Data?.data?.event);
        setZLuckSearch(re_Data?.data?.zodiac);
        setDays(re_Data?.data?.days);
      } else {
        swal("Oops", re_Data?.message, "error");
      }

    }).catch (error => {
    
    })

    //getDataByDate('');
    calculateDate ('serch');
    const activities = searchParams.get('activities');
    setSearchTitle(activities);
    
  },[global.selLang]);
  
  const getDataByDate = (fdate) => {
    const postData = {fdate: fdate};
    axios.post(process.env.REACT_APP_API_KEY+"api/festival", postData,
    {
      headers: {
      "Content-type": "Application/json",
      "Accept": "Application/json",
      "Authorization": `Bearer `+token,
      "sellang": localStorage.getItem("selectLang")
      }   
    }).then((res) => {
      console.log('AAA');
      var reData = res.data; 
      if(reData.status == true){
        var reFullData = reData.data;
        setDisDay (reFullData.date.day);
        setDisDate(reFullData.date.date);
        setDisMonthYear(reFullData.date.my);
        setJieQiStart(reFullData.festival_jie.dis_s_label);
        setJieQiEnd(reFullData.festival_jie.dis_e_label);
        
        setMulLeft(reFullData.mulLeft);
        setChDate(reFullData.chDate);
        setHourFore(reFullData.resHFor);
        setZLuck(reFullData.zodiac.luck);
        setZHealth(reFullData.zodiac.health);
        setZCareer(reFullData.zodiac.career);
        setZWealth(reFullData.zodiac.wealth);

        setGood(reFullData.good);
        setBad(reFullData.bad);
        setSuitLeft(reFullData.rating.suit);
        setAvoid(reFullData.rating.avoid);
        const ratingVal = reFullData.rating.rating;

        console.log('*Rating: ', ratingVal);
        console.log('Ssuit ', suitLeft);
        console.log('Rating Data',reFullData.rating);
        
        setLunarCalenderData(reFullData.lunarData);
      const starData = [];
      for (let i = 0; i < ratingVal; i++) {
          starData.push(<img src={RedStar} alt="" />);
      }
      for (let i = 0; i < (5-ratingVal); i++) {
          starData.push(<img src={GreyStar} alt="" />);
      }
      

      setStarRating(starData);
        
        if(reFullData.festival){
          setHolidays(reFullData.festival.dis_label);
          if(reFullData.festival.dis_label_ter){
             setHolidaysTer(reFullData.festival.dis_label_ter);
          } else {
           setHolidaysTer('');
          }
          
        } else {
          setHolidays('');
          setHolidaysTer('');
        }
        

        if(reFullData.concerns)
          setSan(reFullData.concerns.san);
        else
          setSan('');
        if(reFullData.concerns)
          setYang(reFullData.concerns.yang);
        else
          setYang('');
        if(reFullData.concerns)
          setEarth(reFullData.concerns.earth);
        else
          setEarth('');

        if(reFullData.concerns)
          setGong(reFullData.concerns.gong);
        else
          setGong('');

      if(reFullData.concerns)
        setBreaker(reFullData.concerns.breaker);
      else
        setBreaker('');

        console.log(reFullData);
      }
      
      setClicked('');
    }).catch (error => {
      if(error.response.status == 401 && error.response.data.message == 'Unauthenticated.') {
         localStorage.removeItem("token")
         localStorage.removeItem("userData")
         localStorage.removeItem("fname")
         localStorage.removeItem("lname")
         localStorage.removeItem("nameImage")
         localStorage.removeItem("otpCounter")
         localStorage.removeItem("USERLOGIN")
         navigate("/");
      } else {
        swal("Oops", "Something went wrong.", "error");
      }
      setClicked('');
      console.log(error.response.data.message)
      console.log(error.response.status);
      //console.log(error.response.status);
        // localStorage.removeItem("token")
        // localStorage.removeItem("userData")
        // localStorage.removeItem("fname")
        // localStorage.removeItem("lname")
        // localStorage.removeItem("nameImage")
        // localStorage.removeItem("otpCounter")
        // localStorage.removeItem("USERLOGIN")
        //navigate("/");
    })
    

      
  } /* function close */


  const calculateDate = (callFrom) => {
    
    if(startDate == null){
      var makeDate = new Date();
    } else {
      var makeDate = new Date(startDate);
    }
    var currTime = makeDate.getTime()
    var maxDate = new Date('2100-12-31') //12/31/2100
    var maxDateTime = maxDate.getTime()
    var minDate = new Date('2022-01-02') //1/1/2022
    var minDateTime = minDate.getTime()
    
    if(makeDate < minDateTime)
    {
      console.log('MINDATE>>>');
    }
    

    if (callFrom == 'previous') {
      console.log('previous');
      makeDate.setDate(makeDate.getDate() - 1);
    } else if(callFrom == 'next') {
      console.log('next');
      makeDate.setDate(makeDate.getDate() + 1);
    }
    var newDate =  new Date(makeDate);
    setStartDate(newDate);
    //setDisDay (newDate.getDate());
    var php_date = newDate.getFullYear()+'-'+(newDate.getMonth()+1)+'-'+newDate.getDate();
    getDataByDate(php_date);
    console.log("Call From: ", php_date);
    //console.log(makeDate.getMonth());
    //console.log(makeDate.getDate());
    //setStartDate(new Date('2022-03-15'));
  }
  
  const getAuspiciousDataByDate = () => {
    //const postData = {'activities': searchTitle, 'from_date': searchSDate, 'to_date': searchEDate, 'zodiac': '' };
    axios.get(process.env.REACT_APP_API_KEY+"api/auspicious-search",
    {
      params: {
        zodiac: selectedIds,
        activities: searchTitle
        
      },
      headers: {
      "Content-type": "Application/json",
      "Accept": "Application/json",
      "Authorization": `Bearer `+token,
      "sellang": localStorage.getItem("selectLang")
      }   
    }).then((res) => {
      console.log('AAAAAA>>>', res.data);
      var reData = res.data; 
      
      if(reData.status == true){ // ?.
        console.log('reFullData',reData);
        setSearchData(reData?.data);
        console.log('AAAAAA>>>A', searchData);
      }
      
      setClicked('');
    }).catch (error => {
      console.log('AAAAAA>>>QQ', error);
      if(error?.response?.status == 401 && error?.response?.data?.message == 'Unauthenticated.') {
         localStorage.removeItem("token")
         localStorage.removeItem("userData")
         localStorage.removeItem("fname")
         localStorage.removeItem("lname")
         localStorage.removeItem("nameImage")
         localStorage.removeItem("otpCounter")
         localStorage.removeItem("USERLOGIN")
         navigate("/");
      } else {
        swal("Oops", "Something went wrong.", "error");
      }
      setClicked('');
      
     
    })
    

      
  } /* function close */

  const handleChangeDays = (event) => {
    const checked_id = event.target.value;
    if(event.target.checked){
      setSelectedDays([...selectedDays,checked_id])
    } else{
      setSelectedDays(selectedDays.filter(id=>id !== checked_id))
    }
    console.log("ItemCheckDays", selectedDays)
  }

  const handleChange = (event) => {
    const checkedId = event.target.value;
    if(event.target.checked){
     setSelectedIds([...selectedIds,checkedId])
    } else{
     setSelectedIds(selectedIds.filter(id=>id !== checkedId))
    }
    console.log("ItemCheck1", selectedIds)
  }

  const serchAuspicious = () => {
    if(searchSDate == null){
      var from_date = new Date();
    } else {
      var from_date = new Date(searchSDate);
    }
    var from_date = from_date.getFullYear()+'-'+(from_date.getMonth()+1);//+'-01';

    if(searchEDate == null){
      var to_date = new Date();
    } else {
      var to_date = new Date(searchEDate);
    }
    var to_date = to_date.getFullYear()+'-'+(to_date.getMonth()+1); //+'-'+to_date.getDate();;
    
    
    
    var search_title = searchTitle;
    if(searchTitle == null || searchTitle == 'null'){
      var search_title = '';;
    } 
    
    navigate("/search-res?activities="+search_title+"&from_date="+from_date+"&to_date="+to_date+"&zodiac="+selectedIds+"&days="+selectedDays);
    

    setclickedType('searchAuspicious');
    setClicked('noaction');
    console.log('SSS: ');
    console.log(searchTitle);
    console.log(searchSDate);
    console.log(searchEDate);

    getAuspiciousDataByDate()
    //setClicked('');
  }
  const serchData = () => {
    setclickedType('searchDate');
    setClicked('noaction');
    calculateDate ('serch');
  }
  const previousData = () => {
    setclickedType('searchDate');
    setClicked('noaction');
    calculateDate ('previous');
  }
  const nextData = () => {
    setclickedType('searchDate');
    setClicked('noaction');
    calculateDate ('next');
  }

return (
  <>
    <div className="feature features-header">
      
      <div className="calendar-box">
        <div className="row align-items-center mb-5">
          <div  className="col-sm-5">
            <div className="banner-select p-3">
              <p>{t('festival_calendar')}</p>
              <div className="row">
                <div className="col-sm-8">
                  <div className="date-cover">
                  <DatePicker name="seldate" maxDate={new Date("12/31/2100")} minDate={new Date("1/1/2022")} dateFormat = "dd/MM/yyyy" selected={startDate} onChange={(date) =>   
                  setStartDate(date)} /> 
                  </div>
                </div>
                <div className="col-sm-4">
                  <button type="button" onClick={serchData} disabled = {clicked == 'noaction' ? 'disabled': ''} class={`btn-red-bg btn btn-md nav-btn02 fill02 ${clicked}`}>
                    {clicked == 'noaction' ? 'Loading...': t('festival_search_btn')}
                  </button>
                </div>
                <div>
                {/* <div className="d-flex">
                  <button type="button" onClick={serchData} disabled = {clicked == 'noaction' ? 'disabled': ''} class={`btn-red-bg btn btn-md nav-btn02 fill02 ${clicked}`}>
                    {clicked == 'noaction' ? 'Loading...': t('festival_search_btn')}
                  </button>
                </div> */}
                  {/*<!---Auspicious-----> */}
              {/*<!----Auspicious----> */}
                </div>
              </div>
            </div>
          </div>
          {/*<!---Auspicious-----> */}
          <div className="col-sm-7">
            <div className="card rounded-0">
            <div className="card-body">
              <form action="" method="get">
                <div> 
                  <h3 className="mb-4">{t('auspicious_title')}</h3>
                </div>
                <div className="row mb-3">
                  <div className="col-sm-2">
                    <label for=""><strong>{t('auspicious_event')}</strong></label>
                  </div>
                  <div className="col-sm-10">
                    <select name="" id="" className="form-control" onChange={e => setSearchTitle(e.target.value)}>
                      <option value=""></option>

                      {allEvents.map(allEvent => (
                        <option selected = {(allEvent.suit_activities == searchTitle) ? 'selected' : ''} value={allEvent.suit_activities}>{allEvent.suit_activities}</option>
                      ))}

                    </select>
                    
                    </div>
                </div>
                
              <div className="row mb-3">
                <div className="col-sm-6">
                  <div className="date-picker">
                    <label for=""><strong>{t('auspicious_from')}</strong></label>
                    <DatePicker showMonthYearPicker className="form-control"  name="seldate" maxDate={new Date("12/31/2100")} minDate={new Date("1/1/2022")} dateFormat = "MM/yyyy" selected={(searchSDate) ? new Date(searchSDate) : startDate} onChange={(date) =>   
                  setSearchSDate(date)} />  
                  </div>
                  </div>

                <div className="col-sm-6">
                  <div className="date-picker">
                    <label for=""><strong>{t('auspicious_to')}</strong></label>
                    <DatePicker  showMonthYearPicker className="form-control" name="seldate" maxDate={new Date("12/31/2100")} minDate={new Date("1/1/2022")} dateFormat = "MM/yyyy" selected={(searchEDate) ? new Date(searchEDate) : startDate} onChange={(date) =>   
                  setSearchEDate(date)} />
                  </div>
                </div>

              </div>
              <div className="row">
                <div className="col-sm-12">
                  <label for=""><strong>{t('auspicious_res_days')}</strong></label>
                </div>
              </div>
              <div className="row mb-3">
                <div className="col-sm-12">
                  <div className="row">
                    {days.map(zluck => (
                      <div className="col-sm-3">
                        <input checked={selectedDays.includes(zluck.id)} className="form-check-input" type="checkbox" value={zluck.id} onChange={handleChangeDays}  id={'luck_check_'+zluck.id}/>
                        <label className="form-check-label" for={'luck_check_'+zluck.id}>{zluck.header}</label>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-sm-12">
                  <label for=""><strong>{t('auspicious_res_zodiac')}</strong></label>
                </div>
              </div>
                <div className="row">
                  <div className="col-sm-9">
                    <div className="row">
                      {zLuckSearch.map(zluck => (
                        <div className="col-sm-3">
                          <input checked={selectedIds.includes(zluck.id)} className="form-check-input" type="checkbox" value={zluck.id} onChange={handleChange}  id={'luck_check_'+zluck.id}/>
                          <label className="form-check-label" for={'luck_check_'+zluck.id}>{zluck.header}</label>
                        </div>
                      ))}
                    </div>
                  </div>

                  
                  <div className="col-sm-3">
                    <div className="row">
                    <button type="button" onClick={serchAuspicious} disabled = {clicked == 'noaction' ? 'disabled': ''} class={`btn-red-bg btn btn-md nav-btn02 fill02 ${clicked}`}>
                      {clicked == 'noaction' ? 'Loading...': t('auspicious_search_btn')}
                    </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
            </div>
          </div>
          {/*<!----Auspicious----> */}
        </div>
      </div>
    </div>
    
    {(clickedType == "searchAuspicious" ? (
      <div className="bg-grey">
        <div className="main-section-box">
          <div className="">
            <div className="zodiac-container auspicious shadow-none p-0 mt-0">
            <p className="head">Auspicious Date Finder Result</p>
            <div className="">
              <ul style={{listStyle: "none", paddingLeft: '0'}}>
                <li>Event: {searchTitle}
                </li>
                <li>Period: {searchData?.period}
                </li>
                <li>Zodiac Involved: [Based on what being selected in previous page, eg: Buying New Car]
                </li>
                <li>Total: <big className="count" style={{color: "#f00", fontWeight: 'bold'}}>{searchData?.rows?.length}</big> days
    </li>
              </ul>
            </div>
            <div className="line"></div>
            <div className="mt-4">
            
            <Table responsive="xl" className="zodiac-table">
            <thead>
              <tr>
                <th>日期 <br/> Date</th>
                <th>星期 <br/> Day</th>
                <th>指数 <br/> Rating</th>
                <th>农历 <br/> Lunar Date</th>
                <th>年干支 <br/> Year</th>
                <th>月干支 <br/> Month</th>
                <th>日干支 <br/> Day</th>
                <th>飞星 <br/> Flying Stars</th>
                <th>星宿 <br/> 28 Mansions</th>
                <th>建除 <br/> Day Officer</th>
                <th>冲犯 <br/> Conflict</th>
                <th>备注 <br/> Concerns</th>
              </tr>
            </thead>
            <tbody>
              
              {searchData?.map(search_data => (
                <tr>
                  <td class="text-red">BEST</td>
                  <td class="text-red">BEST</td>
                  <td class="text-black">BAD</td>
                  <td class="text-grey">AVERAGE</td>
                  <td class="text-red">BEST</td>
                  <td class="text-grey">AVERAGE</td>
                  <td class="text-black">BAD</td>
                  <td class="text-black">BAD</td>
                  <td class="text-red">BEST</td>
                  <td class="text-grey">AVERAGE</td>
                  <td class="text-black">BAD</td>
                  <td class="text-grey">AVERAGE</td>
                </tr>
              ))}   

              
              
              </tbody>
              </Table>
            </div>
            </div>
            

          </div>
        </div>
      </div>
    ) : (
    <div className="bg-grey">
      <div className="main-section-box">
        <div className="grid-box">
          <div className="items item-1">
            <div id="item-1-head">
              <div className="select-dropdown">{disMonthYear}</div>
              <p className="Day">{disDay}</p>
            </div>
            <div className="date-count-container">
              <div className="date-count-box">
                <button type="button" disabled = {clicked == 'noaction' ? 'disabled' : ''} class={`date-arrow ${clicked}`} onClick={previousData}><img src={Arrow} alt="" /></button>
                <div className="date-count">
                    <span>{disDate}</span>
                </div>
                <button type="button" disabled = {clicked == 'noaction' ? 'disabled' : ''} class={`date-arrow02 ${clicked}`} onClick={nextData}><img src={Arrow} alt="" /></button>
              </div>
             <div className="date-detail">
              <p>{lunarCalenderData.lunarData}</p>
              <p>{chDate}</p>
             </div>
            </div>
            <div className="star-rating-box">
              {starRating.map(sRating => (
                <>{sRating}</>
              ))}
             
            </div>
            <div className="bottom-text">
            <span>{holidays}</span><span> {holidaysTer} </span>
            </div>
          </div>
          <div className="items item-2">
            <div className="item-head">
              <p>{t('festival_suit')}</p>
            </div>
            <div className="d-flex w-100 ul-container">
              <ul className ="activities">
              {suitLeft.map(suitName => (
                <li>{suitName}</li>
              ))}
              </ul>
            </div>
            <div className="border-2"></div>
            <p className="footer-text01">
              <i>{jieQiStart}</i>
            </p>
          </div>
          <div className="items item-3">
            <div className="item-head">
              <p>{t('festival_avoid')}</p>
            </div>
            <div className="w-100 ul-container d-flex">
              <ul className="activities">
                {avoid.map(avoidName => (
                  <li>{avoidName}</li>
                ))}
              </ul>
            </div>
            <div className="border-2"></div>
            <p className="footer-text01">
              <i>{jieQiEnd}</i>
            </p>
          </div>
          <div className="items item-4">
            <div className="item-head">
              <p>{t('festival_good')}</p>
            </div>
              <div className="w-100 ul-container d-flex">
                <ul className="good-bad">
                  {good.map(r_bad => (
                  <li><span>{r_bad.dis_header}</span> <span>{r_bad.dis_labe}</span></li>
                  ))}
                </ul>
              </div>
          </div>
          <div className="items item-5">
            <div className="item-head">
              <p>{t('festival_bad')}</p>
            </div>
              <div className="w-100 ul-container d-flex">
                <ul className="good-bad">
                {bad.map(r_bad => (
                  <li><span>{r_bad.dis_header}</span> <span>{r_bad.dis_labe}</span></li>
                  ))}                  
                </ul>
              </div>
          </div>
          <div className="items item-6">
            <div className="w-100 ul-container d-flex text-grey">
              <ul className="good-bad">
                {mulLeft.map(mul_left => (
                <li><span>{mul_left.header}</span> <span>{mul_left.label}</span></li>
                ))}
                  
              </ul>
              
            </div>
          </div>
          <div className="items item-7">
            <div className="item-head">
              <p>{t('festival_conce')}</p>
            </div>
              <div className="w-100 ul-container d-flex">
                <ul>
                  <li>
                    <i>{san}</i>
                  </li>
                  <li>
                    <i>{yang}</i>
                  </li>
                  <li>
                    <i>{earth}</i>
                  </li>
                  <li>
                    <i>{gong}</i>
                  </li>
                  <li>
                    <i>{breaker}</i>
                  </li>

                </ul>
              </div>
          </div>
        </div>
      </div>
      <div className="forecast-container">
        <p className="head">{t('festival_h_forecast')}</p>
        <div className="line"></div>
        <div className="forecast-box">
          
        {hourFore.map(hour_fore => (
          <div className="forecast-item">
            <div className="forecast-card">
              <p>{hour_fore.name}</p>
              <span><i>{hour_fore.time}</i></span>
            </div>
              <div className={`forecast-label ${hour_fore.color}`}>
                <span>{hour_fore.res}</span>
              </div>
          </div>
        ))}
        </div>
      </div>
      <div className="zodiac-container">
        <p className="head">{t('festival_z_forecast')}</p>
        <div className="line"></div>
        <div className="mt-4">
        
        <Table responsive="xl" className="zodiac-table">
        <thead>
          <tr>
            <th></th>
            {zLuck.map(zluck => (
            <th>{zluck.header}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          <tr>
          <td className="text-black02">{t('zodiac_luck')}</td>
          {zLuck.map(z_luck => (
            <td className={z_luck.color_class}>{z_luck.dis_labe}</td>
          ))}
          </tr>
          <tr>
          <td className="text-black02">{t('zodiac_health')}</td>
          {zHealth.map(z_health => (
            <td className={z_health.color_class}>{z_health.dis_labe}</td>
           ))}
          </tr>
          <tr>
          <td className="text-black02">{t('zodiac_career')}</td>
          {zCareer.map(z_career => (
            <td className={z_career.color_class}>{z_career.dis_labe}</td>
          ))}
          
          </tr>
          <tr>
          <td className="text-black02">{t('zodiac_wealth')}</td>
          {zWealth.map(z_wealth => (
            <td className={z_wealth.color_class}>{z_wealth.dis_labe}</td>
          ))}
          </tr>
          </tbody>
          </Table>
        </div>
      </div>
      <div className="calendar-container">
      <p className="head">{t('festival_m_calendar')}</p>
        <div className="line"></div>
      <div className="mt-5">
      <Full_Calendar
        
        />
      </div>
      </div>
    </div>
    )
    )}
  </>
);
}

export default Features;
